<template>
  <el-card class="create-campaign" v-loading="loading">
    <div class="preload-image1"></div>
    <div class="preload-image2"></div>
    <div class="preload-image3"></div>
    <div class="wrapper" id="guide-step5">
      <section class="panel mt-6" style="padding-bottom: 4px;">
        <div class="divider">
          <h3>{{$t('messages.myCampaign.list12')}}</h3>
        </div>
        <div class="content-box">
          <div class="content-box-lists">
            <el-tooltip class="item" effect="dark" :content="$t('messages.createCampaign.create112')" placement="bottom">
              <div :class="{'lists-item':true,'itemActive':form.cp_type === 1}" 
                @click="chooseBusiness(0)">
                <img src="../../assets/img/combo-package.png" width="96" class="img" />
                <img src="../../assets/img/right-gou.png" class="img2" v-if="form.business_type === 0"/>
                <p>{{$t('messages.createCampaign.create74')}}</p>
              </div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t(`messages.createCampaign.${item.langKey}`)" placement="bottom" v-for="(item, i) in typeData" :key="item.id">
              <div :class="{'lists-item':true,'itemActive':form.business_type === item.id}" 
                @click="chooseBusiness(item.id)">
                <img 
                  src="../../assets/img/hot-logo.png" 
                  class="hot-logo"
                  v-if="item.id === 3 || item.id === 7"
                />
                <img 
                  src="../../assets/img/new-logo.png" 
                  class="hot-logo new-logo"
                  v-if="offlineTypes.includes(item.id)"
                />
                <img :src="require(`../../assets/img/${item.icon}.png`)" width="96" class="img" />
                <img src="../../assets/img/right-gou.png" class="img2" v-if="form.business_type === item.id"/>
                <p>{{ $t(`messages.createCampaign.${item.nameLangKey}`) }}</p>
              </div>
            </el-tooltip>
                  
            <!-- <div :class="{'lists-item':true,'itemActive':mediaType}" 
              @click="chooseBusiness(8)">
              <img src="../../assets/img/media.png" width="96" class="img" />
              <img src="../../assets/img/right-gou.png" class="img2" v-if="mediaType"/>
              <p>Media</p>
            </div> -->
            
            <div :class="{'lists-item':true,'itemActive':socialMediaTypeComputed}" 
              @click="chooseBusiness(16)">
              <img 
                src="../../assets/img/new-logo.png" 
                class="hot-logo new-logo"
              />
              <img src="../../assets/img/media.png" width="96" class="img" />
              <img src="../../assets/img/right-gou.png" class="img2" v-if="socialMediaTypeComputed"/>
              <p>{{$t('messages.createCampaign.create6')}}</p>
            </div>
          </div>
        </div>
        <p v-if="typeErr" style="color: #f56c6c;font-size: 12px;padding-top: 4px;">
          {{$t('messages.createCampaign.create72')}}
        </p>
      </section>
      <section class="panel mt-6">
        <div class="divider">
          <h3 class="divider-tips basic-info">{{$t('messages.createCampaign.create32')}}</h3> 
        </div>
        <div class="tip-box" v-if="isOfflineTypeComputed">{{ $t(`messages.createCampaign.${offlineTypeTips[form.business_type]}`) }}</div>
        <div class="tip-box" v-if="socialMediaTypeComputed">{{$t('messages.createCampaign.create122')}}</div>
        <div class="content-box">
          <div class="form-container">
            <el-form
              ref="createCampaign"
              :model="form"
              :rules="rules"
              label-position="right"
              label-width="180px"
            >
              <el-row v-if="$store.state.profile.campaign_new_user" class="free_trial_form_row">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create185')" class="free_trial_form">
                    <el-switch v-model="freeTrial"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="mode === 'detail' && id">
                <el-col>
                  <div class="status-box">
                    <div class="status-label">{{ $t('messages.myCampaign.list5') }}</div>
                    <div class="status-value">
                      {{ showLabel(status, asoGrowOption.asogrow_campaign_status) }}
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="mode === 'detail' && id">
                <el-col>
                  <el-form-item :label="$t('messages.myCampaign.list8')">
                    <el-input v-model="id" disabled class="formWidth"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="$store.state.profile.customer_type === 1">
                <el-col>
                  <el-form-item :label="$t('messages.myCampaign.list7')" prop="developer_name" class="country-form">
                    <el-input 
                    v-model="form.developer_name" 
                    class="formWidth" 
                    :placeholder="$t('messages.createCampaign.create75')"
                    :disabled="mode === 'detail'">
                  </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="!mediaType||isCombo"> 
                
                <template v-if="socialMediaTypeComputed">
                  <el-row>
                    <el-col>
                      <el-form-item :label="$t('messages.createCampaign.create46')" prop="media_platform" key="media_platform">
                        <el-select
                          v-model="form.media_platform"
                          :placeholder="$t('messages.createCampaign.create46')"
                          class="formWidth"
                          @change="changeMediaPlatform"
                        >
                          <el-option
                            v-for="(item, i) in asoGrowOption.asogrow_media_platform"
                            :key="i"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item :label="$t('messages.createCampaign.create47')" prop="media_target" key="media_target">
                        <el-select
                          v-model="form.media_target"
                          :placeholder="$t('messages.createCampaign.create47')"
                          class="formWidth"
                        >
                          <el-option
                            v-for="(item, i) in mediaTargetOptionsComputed"
                            :key="i"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item :label="$t('messages.createCampaign.create48')" prop="reviewer_name">
                        <el-input v-model.trim="form.reviewer_name" class="formWidth" :placeholder="$t('messages.createCampaign.create48')"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item :label="$t('messages.createCampaign.create49')" prop="review_url">
                        <el-input v-model.trim="form.review_url" class="formWidth" :placeholder="$t('messages.createCampaign.create49')"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                
                <el-row v-else>
                  <el-col>
                    <el-form-item
                      :label="$t('messages.createCampaign.create54')"
                      prop="app_store_url"
                      style="margin-bottom: 30px;"
                    >
                      <el-select
                        v-model="form.app_store_url"
                        size="medium"
                        @change="handleChangeCountry(1)"
                        v-if="applications.length>0"
                        class="app-select-wrap formWidth"
                        @focus="setOptionWidth"
                        :placeholder="$t('messages.other.other54')"
                      >
                        <div slot="prefix" class="app-select-prefix-icon" v-if="selectObj.imgUrl">
                          <img :src="selectObj.imgUrl" alt="icon url" width="22px"/>
                        </div>
                        <el-option
                          v-for="(item, i) in applications"
                          :key="i"
                          :label="`${item.app_name}`"
                          :value="item.app_store_url"
                          class="app-select-option"
                          :style="{width:selectOptionWidth || 'auto'}"
                          @click.native="changeCountryOption(i)"
                        >
                          <img :src="item.icon_url" alt="icon url" class="img" loading="lazy"/>
                          <p class="name">{{item.app_name}}</p>
                        </el-option>
                      </el-select>
                      <div v-else class="add-new-app" @click="showAddApp">
                        <p>+</p>
                        <p>{{$t('messages.createCampaign.create76')}}</p>
                      </div>
                      <div class="tip-message" v-if="applications.length>0">
                        {{$t('messages.createCampaign.create8')}} <span @click="showAddApp">{{$t('messages.createCampaign.create55')}}</span>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item :label="$t('messages.createCampaign.create7')" prop="country" class="country-form">
                      <el-select
                        v-model="form.country"
                        size="medium"
                        class="formWidth"
                        @change="(val)=>handleChangeCountry(2,val)"
                        filterable
                        @focus="setOptionWidth"
                        :placeholder="$t('messages.other.other54')"
                      >
                        <el-option
                          v-for="(item, i) in countryOptionsCom"
                          :key="i"
                          :label="item.name"
                          :value="item.id"
                          :style="{width:selectOptionWidth || 'auto'}"
                          :disabled="countryDisabled(item.id)"
                        ></el-option>
                      </el-select>
                      <div class="tip-message" v-if="freeTrialUse">
                        {{$t('messages.createCampaign.create56')}}
                      </div>
                      <div class="tip-message" v-else>
                        {{$t('messages.createCampaign.create9')}}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <el-row>
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create11')" prop="tz">
                    <el-select v-model="form.tz" class="formWidth" :placeholder="$t('messages.other.other54')">
                      <el-option
                        v-for="(item, i) in timezoneOptions"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <div class="tip-message">
                      {{ $t('messages.createCampaign.create12') }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="otherCountry">
                <el-col>
                  <el-form-item
                    :label="$t('messages.createCampaign.create77')"
                    prop="promotion_days"
                  >
                    <el-input-number
                      v-model="form.promotion_days"
                      :precision="0"
                      :controls="false"
                      :min="1"
                      @change="
                        value => {
                          changePromotionDays(value)
                        }
                      "
                    />
                    
                    <div class="tip-message" style="color: #1861F2;">
                      {{$t('messages.createCampaign.create78')}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create13')" prop="schedule">
                    <el-date-picker
                      v-model="form.schedule"
                      type="daterange"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :range-separator="$t('messages.other.other63')"
                      :start-placeholder="$t('messages.createCampaign.create161')"
                      :end-placeholder="$t('messages.createCampaign.create190')"
                      :picker-options="pickerOptions"
                      @change="changeTimeSchedule"
                      class="formWidth"
                      popper-class="popperClass"
                      :disabled="freeTrialUse"
                    ></el-date-picker>
                    <div class="tip-message">
                      {{ $t('messages.createCampaign.create14') }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="showMediaComment">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create57')" prop="comments_file">
                    <!-- <el-select v-model="form.tz" class="formWidth">
                      <el-option
                        v-for="(item, i) in timezoneOptions"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select> -->
                    <el-upload
                      class='file-row'
                      action="/api/data/file/upload/"
                      :data="{
                        relative_s3_dir: 'creative',
                        if_hide: 0,
                        if_remain_origin: 0,
                        bucket: 'adimage',
                      }"
                      accept=".xls,.txt,.csv,.xlsx"
                      :file-list="commentFileList"
                      :limit="1"
                      :on-success="handleCommentSuccess"
                      :before-upload="handleCommentBefore"
                      :on-remove="handleCommentRemove"
                      :on-change="handleCommentChange"
                      style="width:fit-content;"
                    >
                      <el-button type="primary" style="margin-right: 10px;" v-if="commentFileList.length === 0">{{$t('messages.home.tip58')}}</el-button>
                    </el-upload>
                    <div class="tip-message" style="margin-top: 6px;">
                      {{$t('messages.createCampaign.create82')}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isCombo">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create26')" class="combo-wrap" prop="cp_type">
                    <el-form ref="comboCampaign" :model="combo" class="combo-wrap-form"
                      :rules="comboRules" label-width="150px" label-position="left">
                      <el-row class="combo-row">
                        <el-col>
                          <h1 style="font-weight: 500;font-size: 14px;">{{ $t('messages.createCampaign.create27') }}</h1>
                          <el-form-item :label="$t('messages.createCampaign.create21')" prop="cap1" class="combo-row-item">
                            <el-input v-model.number="combo.cap1" style="width: 180px;" @change="changeCap1"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row class="combo-row">
                        <el-col>
                          <h1 style="display:inline-block;font-weight: 500;font-size: 14px;">{{$t('messages.createCampaign.create28')}}</h1>
                          <el-popover
                            width="284"
                            trigger="hover"
                            placement="right" 
                            :content="$t('messages.other.other22')">
                            <i
                              class="iconfont icon-icon_tips tip-icon"
                              style="margin-left: 4px;"
                              slot="reference"
                            ></i>
                          </el-popover>
                          
                          <el-form-item :label="$t('messages.createCampaign.create21')" prop="cap2" class="combo-row-item">
                            <el-input v-model.number="combo.cap2" style="width: 180px;"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row class="combo-row" id="combo-row-review">
                        <el-col>
                          <h1 style="display:inline-block;font-weight: 500;font-size: 14px;">{{$t('messages.createCampaign.create29')}}</h1>
                          <el-popover
                            class="combo-row-popover"
                            width="284"
                            trigger="hover"
                            placement="right" 
                            >
                            <i
                              class="iconfont icon-icon_tips tip-icon"
                              style="margin-left: 4px;"
                              slot="reference"
                            ></i>
                            <div>
                              {{$t('messages.other.other21')}}
                              <br/>
                              2.{{$t('messages.other.other14')}}
                              <br/>
                              3.{{$t('messages.other.other15')}}
                            </div>
                          </el-popover>
                          <div class="combo-row-content">
                            <div class="combo-row-content-right">
                              <review-com 
                                :list="comboList" 
                                :allList="reviewComboList" 
                                @handleReviewAdd="handleReviewAdd"
                                @handleDeleteAll="handleDeleteAll"
                                @handlePageList="handlePageList"
                                @changeReview="changeReview"
                                @handleImport="handleImport"
                                ref="comboListRef"
                                type="combo"
                                :country="form.country"
                                :app_store_url="form.app_store_url"
                                @openGenerated="openGenerated"
                              ></review-com>
                              <p v-if="goodReviewNumErr === 'capErr'" class="err-tip" id="err-tip">
                                {{ $t('messages.other.other23') }}
                              </p>
                              <p v-else-if="goodReviewNumErr === 'dayErr'" class="err-tip" id="err-tip">
                                {{ $t('messages.createCampaign.create99') }}
                              </p>
                              <div :class="{'terms-div':true,'terms-div-err':showTermErr}" id="termsDiv" style="margin-left: 0;">
                                <el-checkbox-group v-model="termsCheck">
                                  <el-checkbox @change="changeTermCheck">
                                    {{ $t('messages.other.other24') }}
                                    <span style="color: #f56c6c;" @click.stop="(e)=>showPay(e,1)">{{ $t('messages.other.other25') }}</span>
                                  </el-checkbox>
                                </el-checkbox-group>
                              </div>
                            </div>                                                   
                          </div>
                        </el-col>
                      </el-row>
                    </el-form>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="mediaType">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create186')" prop="business_type" key="business_type">
                    <el-select
                      v-model="form.business_type"
                      :placeholder="$t('messages.other.other34')"
                      class="formWidth"
                    >
                      <el-option
                        v-for="(item, i) in mediaOptionsList"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                        :disabled="item.id === 9"
                      ></el-option>
                    </el-select>
                    <div class="tip-message">
                      The settlement data of each media type is based on the platform data.
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="showTerm && !isCombo">
                <el-col>
                  <div :class="{'terms-div':true,'terms-div-err':showTermErr}" id="termsDiv">
                    <el-checkbox-group v-model="termsCheck">
                      <el-checkbox @change="changeTermCheck">
                        {{ $t('messages.other.other24') }}
                        <span style="color: #f56c6c;" @click.stop="(e)=>showPay(e,1)">{{ $t('messages.other.other25') }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="mediaType || socailMediaInsOrYtbFollow">
                <el-col>
                  <el-form-item :label="socailMediaInsOrYtbFollow ? $t('messages.createCampaign.create50') : getNewTypeValue(2)" prop="avatar">
                    <el-upload
                      :class="{ hide: hideAvatarUpload }"
                      action="/api/data/file/upload/"
                      :data="{
                        relative_s3_dir: 'creative',
                        if_hide: 0,
                        if_remain_origin: 0,
                        bucket: 'adimage',
                      }"
                      list-type="picture-card"
                      accept=".jpg, .jpeg, .gif, .png"
                      :file-list="avatarFileList"
                      :limit="1"
                      :on-success="handleAvatarSuccess"
                      :before-upload="handleAvatarBefore"
                      :on-remove="handleAvatarRemove"
                      :on-change="handleAvatarChange"
                      style="width:148px;"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="tip-message">
                      {{ $t('messages.createCampaign.create188') }}
                      <!-- <a class="tip-message-a" @click="setImg(defaultImg)" v-if="!mediaType">Use default picture</a> -->
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="insPostBannerType">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create187')" prop="post_banner">
                    <el-upload
                      :class="{ hide: hidePostBannerUpload }"
                      action="/api/data/file/upload/"
                      :data="{
                        relative_s3_dir: 'creative',
                        if_hide: 0,
                        if_remain_origin: 0,
                        bucket: 'adimage',
                      }"
                      list-type="picture-card"
                      accept=".jpg, .jpeg, .gif, .png"
                      :file-list="bannerFileList"
                      :limit="1"
                      :on-success="handleProductImgSuccess"
                      :before-upload="handleProductImgBefore"
                      :on-remove="handleProductImgRemove"
                      :on-change="handleProductImgChange"
                      style="width:148px;"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="tip-message">
                      {{$t('messages.createCampaign.create189')}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!mediaType && !socialMediaTypeComputed">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create15')" prop="img" class="creatives-form-item">
                    <el-upload
                      :class="{ hide: hideProductImgUpload }"
                      action="/api/data/file/upload/"
                      :data="{
                        relative_s3_dir: 'creative',
                        if_hide: 0,
                        if_remain_origin: 0,
                        bucket: 'adimage',
                      }"
                      list-type="picture-card"
                      accept=".jpg, .jpeg, .gif, .png"
                      :file-list="imgFileList"
                      :on-success="handleProductImgSuccess"
                      :before-upload="handleProductImgBefore"
                      :on-remove="handleProductImgRemove"
                      :on-change="handleProductImgChange"
                      style="width:148px;"
                      ref="upload"
                    >
                      <i class="el-icon-upload"></i>
                      <div slot="file" slot-scope="{file}">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url" alt=""
                        >
                        <span class="el-upload-list__item-actions">
                          <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="openUpload"
                          >
                            <i class="el-icon-refresh"></i>
                          </span>
                        </span>
                      </div>
                    </el-upload>
                    <div class="tip-message">
                      {{$t('messages.createCampaign.create16')}}
                      <!-- <a class="tip-message-a" @click="setImg(defaultImg)" v-if="!mediaType">Use default picture</a> -->
                    </div>
                    <div class="tip-message" v-if="!mediaType && form.app_store_url">
                      <a class="tip-message-a" @click="showImgsPop">{{$t('messages.createCampaign.create104')}}</a>
                      {{$t('messages.createCampaign.create105')}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="isGuaranteedReview">
                <el-row>
                  <el-col>
                    <el-form-item :label="$t('messages.createCampaign.create64')">
                      <p>
                        {{ $t('messages.createCampaign.create37') }}
                      </p>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="custom-review-row">
                  <el-col>
                    <el-form-item :label="$t('messages.createCampaign.create38')" prop="lang">
                      <el-select v-model="form.lang" filterable class="formWidth" :placeholder="$t('messages.createCampaign.create136')">
                        <el-option
                          v-for="(item, i) in languageGuaranteedOptions"
                          :key="i"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('messages.createCampaign.create39')" prop="user_category">
                      <el-input v-model="form.user_category" class="formWidth" type="textarea" autosize></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('messages.createCampaign.create40')" prop="attitude">
                      <el-input v-model="form.attitude" class="formWidth" type="textarea" autosize></el-input>
                      <div class="manners">
                        <el-tag
                          v-for="tag in mannerTags"
                          :key="tag"
                          @click="chooseMannerTag(tag)"
                          >
                          {{tag}}
                        </el-tag>
                      </div>
                    </el-form-item>
                    <el-form-item :label="$t('messages.createCampaign.create41')" prop="product_feature">
                      <el-input v-model="form.product_feature" class="formWidth" type="textarea" autosize></el-input>
                      <p class="formWidth mt-2">
                        {{$t('messages.createCampaign.create42')}}
                      </p>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <el-row v-if="form.business_type === 5 || mediaType">
                <el-col>
                  <el-form-item :label="mediaType ? getNewTypeValue(0) : 'Url of Review'" prop="review_url">
                    <el-input v-model.trim="form.review_url" class="formWidth"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="form.business_type === 5 || mediaType">
                <el-col>
                  <el-form-item :label="mediaType ? getNewTypeValue(1) : 'Reviewer name'" prop="reviewer_name">
                    <el-input v-model="form.reviewer_name" class="formWidth"></el-input>
                    <div class="tip-message">
                      {{$t('messages.createCampaign.create102')}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="fiveTypesComputed">
                <el-col>
                  <el-form-item :label="form.business_type === 15 ? $t('messages.createCampaign.create45') : $t('messages.createCampaign.create111')" prop="review_screenshot">
                    <el-upload
                      :class="{ hide: hideReviewScreenshotUpload }"
                      action="/api/data/file/upload/"
                      :data="{
                        relative_s3_dir: 'creative',
                        if_hide: 0,
                        if_remain_origin: 0,
                        bucket: 'adimage',
                      }"
                      list-type="picture-card"
                      accept=".jpg, .jpeg, .gif, .png"
                      :file-list="reviewScreenshotFileList"
                      :limit="1"
                      :on-success="handleReviewScreenshotSuccess"
                      :before-upload="handleReviewScreenshotBefore"
                      :on-remove="handleReviewScreenshotRemove"
                      :on-change="handleReviewScreenshotChange"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="tip-message">
                      {{$t('messages.createCampaign.create103')}}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="free_trial_form_row" v-if="searchKeywordType">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create100')" class="free_trial_form">
                    <el-switch v-model="keywordsInstall" :disabled="form.country === 'US'"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-for="(item, index) in form.info" :key="index">
                <el-row
                  justify="space-between"
                  :gutter="16"
                  v-if="(searchKeywordTypeSupport || form.business_type === 4  || form.business_type === 2) && !isCombo"
                  class="keywords-wrap"
                  >
                  <el-col :span="20">
                    <el-form-item
                      :label="
                        form.business_type === 4
                          ? $t('messages.createCampaign.create90')
                          : searchKeywordType || form.business_type === 2
                          ? $t('messages.createCampaign.create17')
                          : $t('messages.createCampaign.create91')
                      "
                      :prop="`info.${index}.keyword`"
                      :rules="keywordRules"
                      class="keyword-form"
                      style="margin-bottom: 40px;"
                    >
                      <el-input v-model="item.keyword"></el-input>
                      <div class="tip-message" v-if="form.business_type === 4">
                        {{$t('messages.createCampaign.create92')}}
                        <br />
                        {{$t('messages.createCampaign.create93')}}
                      </div>
                      <div class="tip-message" v-else>
                        {{$t('messages.createCampaign.create94')}}
                        <br />
                        {{$t('messages.createCampaign.create95')}}
                        <br />
                        {{$t('messages.createCampaign.create96')}}
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" style="text-align: right;width: 10%;" v-if="!freeTrialUse && !searchKeywordType">
                    <template v-if="index === 0">
                      <el-button
                        type="primary"
                        @click="addKeyword(form.info)"
                        :disabled="form.info.length >= 20"
                      >
                      {{$t('messages.createCampaign.create97')}}
                      </el-button>
                      <p
                        style="color: #f56c6c;font-size: 12px;margin-top: 8px;"
                        v-if="form.info.length >= 20"
                      >
                        Only 20 keywords can be submitted at one time
                      </p>
                    </template>

                    <el-button type="primary" @click="deleteKeyword(index, form.info)" v-else>
                      {{$t('messages.home.tip54')}}
                    </el-button>
                  </el-col>
                </el-row>
                <!-- (form.business_type===7 || form.business_type===11) 9441--> 
                <el-row v-if="custom_review.length>0 && reviewsTypesAndYtbCommentComputed && !isCombo">
                  <el-col class="custom-review-col">
                    <div class="custom-review-col-left">
                      <review-com 
                        :list="custom_review" 
                        :allList="reviewList" 
                        @handleReviewAdd="handleReviewAdd"
                        @handleDeleteAll="handleDeleteAll"
                        @handlePageList="handlePageList"
                        @changeReview="changeReview"
                        ref="reviewListRef"
                        :businessType="form.business_type"
                        :mode="mode"
                      ></review-com>
                      <p v-if="cusReviewNumErr" class="err-tip err-tip-mob" style="margin-top: 10px;margin-left: 150px;">
                        {{ $t('messages.createCampaign.create99') }}
                      </p>
                    </div>
                    <div class="import-btns">
                      <el-button
                        @click="handleExport('list')"
                        style="margin-right: 6px;"
                      >
                        {{$t('messages.myCampaign.list45')}}
                      </el-button>
                      <template v-if="mode !== 'detail'">
                        <el-button
                          type="primary"
                          @click="handleDeleteAll"
                          v-if="reviewList.length > 1"
                          class="delall-btn"
                        >
                          {{$t('messages.home.tip57')}}
                        </el-button>
                        <el-button
                          type="primary"
                          @click="handleImport('list')"
                          class="custom-review-btn"
                        >
                          {{$t('messages.home.tip58')}}
                        </el-button>
                        <el-button
                          class="ai-btn"
                          @click="openGenerated('list')"
                          v-if="(form.country && form.app_store_url) || form.business_type===11"
                        >
                          {{$t('messages.createCampaign.create79')}}
                          <img src="../../assets/img/ai-new.png"/>
                        </el-button>
                      </template>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="!isCombo">
                  <template v-if="form.business_type === 15">
                    <el-col>
                      <el-form-item label="User Name" prop="reviewer_name">
                        <el-input 
                        v-model="form.reviewer_name" 
                        class="formWidth" 
                        placeholder="User Name"
                        :disabled="mode === 'detail'">
                      </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="Review helpfulness vote" prop="review_helpfulness_vote" class="emoji-row">
                        <el-radio-group v-model="form.review_helpfulness_vote">
                          <el-radio :label="1" :value="1">Yes</el-radio>
                          <el-radio :label="0" :value="0">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </template>
                  <el-col>
                    <el-form-item
                      :label="$t('messages.createCampaign.create21')"
                      :prop="`info.${index}.daily_cap`"
                      :rules="dailyCapRules"
                    >
                    <!--   :disabled="form.business_type===7 || form.business_type===11" -->
                      <el-input-number
                        v-model="item.daily_cap"
                        :precision="0"
                        :controls="false"
                        :disabled="reviewsTypesAndYtbCommentComputed"
                        @change="
                          value => {
                            changeDailyCap(value, item)
                          }
                        "
                      />
                      <!-- v-if="form.business_type===7||form.business_type===11" -->
                      <div class="tip-message" v-if="reviewsTypesAndYtbCommentComputed">
                        {{$t('messages.createCampaign.create33')}}
                      </div>
                      <div class="tip-message" v-else>
                        <template v-if="freeTrialUse">
                          {{$t('messages.createCampaign.create101')}}
                        </template>
                        <template v-else>
                          {{$t('messages.createCampaign.create22')}}
                        </template>                  
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="!isCombo">
                  <el-col>
                    <el-form-item
                      :label="$t('messages.myCampaign.list21')"
                      :prop="`info.${index}.total_cap`"
                      :rules="totalCapRules"
                    >
                      <el-input-number
                        v-model="item.total_cap"
                        :precision="0"
                        :controls="false"
                        :disabled="form.business_type!==7"
                        @change="
                          value => {
                            changeTotalCap(value,index)
                          }
                        "
                      />
                      <!-- v-if="form.business_type===7||form.business_type===11" -->
                      <div class="tip-message" v-if="reviewsTypesAndYtbCommentComputed">
                        {{ $t('messages.createCampaign.create34') }}
                        {{ $t('messages.createCampaign.create344') }}
                      </div>
                      <div class="tip-message" v-else>
                        {{ $t('messages.createCampaign.create23') }}
                      </div>
                      <p class="tip-message-err" v-if="showCapErr">{{ $t('messages.createCampaign.create34') }}</p>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-else>
                  <el-col>
                    <el-form-item
                      :label="$t('messages.myCampaign.list21')"
                    >
                      <el-input-number
                        v-model="totalCap"
                        :precision="0"
                        :controls="false"
                        disabled
                      />
                      <div class="tip-message">
                        {{ $t('messages.createCampaign.create23') }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
          <preview-img v-if="!otherCountry && !mediaType" :iconFileList="iconFileList" :resizedImageFileList="resizedImageFileList"
            :hideIconUpload="hideIconUpload" :hideProductImgUpload="hideProductImgUpload" :form="form"></preview-img>
        </div>
        <template v-if="originalCountry.includes(form.country) || !form.country">
          <section class="order-price" v-if="use_total_price_discount">
            <div class="order-price-label">
              {{$t('messages.createCampaign.create24')}}
            </div>
            <div v-if="orderPriceCal" class="order-price-wrap">
              <div class="order-price-top">
                <div class="order-price-top-left" v-if="isCombo">{{$t('messages.myCampaign.list13')}}</div>
                <div class="order-price-top-left" v-else>
                  {{ showLabel(form.business_type, businessTypeOptions) }}
                </div>
                <div class="order-price-top-right">
                  <template v-if="freeTrialUse && !isCombo">
                    <span style="text-decoration: line-through;text-decoration-color: #f56c6c;">{{ orderPriceCalTip }}</span>
                    <span style="margin-left: 4px;color: #f56c6c;">$0</span>
                  </template>
                  <span v-else>{{ orderPriceCalTip }}</span>
                  <i
                    class="iconfont icon-icon_tips tip-icon"
                    style="margin-left: 4px;"
                    @mouseenter="(e)=>showPay(e,2)"
                  ></i>
                </div>
              </div>
              <div class="order-price-bottom" v-if="isCombo">
                <div class="order-price-row">
                  <div>{{ $t(`messages.other.${typeComboPrices[1][0].name}`) }}({{ form.country }})</div>
                  <div>
                    ${{ comPrice1 }} * {{ totCap1 }} = ${{
                      (comPrice1 * totCap1).toFixed(2)
                    }}
                  </div>
                </div>
                <div class="order-price-row">
                  <div>{{ $t(`messages.other.${typeComboPrices[3][0].name}`) }}({{ form.country }})</div>
                  <div>
                    ${{ comPrice2 }} * {{ totCap2 }} = ${{
                      (comPrice2 * totCap2).toFixed(2)
                    }}
                  </div>
                </div>
                <div class="order-price-row">
                  <div>{{ $t(`messages.other.${typeComboPrices[7][0].name}`) }}({{ form.country }})</div>
                  <div>
                    ${{ comPrice3 }} * {{ reviewComboList.length }} = ${{
                      (comPrice3 * reviewComboList.length).toFixed(2)
                    }}
                  </div>
                </div>
              </div>
              <div class="order-price-bottom" v-else-if="!freeTrialUse && (jdCountry || mode === 'detail') && !searchKeywordTypeSupport">
                <div
                  class="order-price-row"
                  v-for="(item, i) in typePrices[form.business_type]"
                  :key="i"
                >
                  <div>{{ $t(`messages.other.${item.name}`) }}({{ mediaType ? 'All' : form.country }})</div>
                  <div>
                    ${{ item[otherCountry || mediaType?'Other':form.country].toFixed(2) }} * {{ sumTotalCap }} = ${{
                      getTotal(item[otherCountry || mediaType?'Other':form.country])
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <i class="iconfont icon-icon_tips tip-icon" @mouseenter="(e)=>showPay(e,2)"></i>
            </div>

          </section>
          <section class="order-price" v-else>
            <div class="order-price-label">
              {{$t('messages.createCampaign.create24')}}
            </div>
            <div v-if="orderPriceCal" class="order-price-wrap">
              <div class="order-price-top">
                <div class="order-price-top-left">{{$t('messages.createCampaign.create73')}}</div>
                <div class="order-price-top-right">
                  <span v-if="isCombo">${{ comPriceTotal }}</span>
                  <template v-else>
                    <template v-if="freeTrialUse">
                      <span style="text-decoration: line-through;text-decoration-color: #f56c6c;">{{ unitPriceTotalTip }}</span>
                      <span style="margin-left: 4px;color: #f56c6c;">$0</span>
                    </template>
                    <span v-else>{{ unitPriceTotalTip }}</span>
                  </template>
                  <i
                    class="iconfont icon-icon_tips tip-icon"
                    style="margin-left: 4px;"
                    @mouseenter="(e)=>showPay(e,2)"
                  ></i>
                </div>
              </div>
              <div class="order-price-bottom" v-if="isCombo">
                <div class="order-price-row">
                  <div>{{ $t(`messages.other.${typeComboPrices[1][0].name}`) }}({{ form.country }})</div>
                  <div>
                    {{ comPriceDiscountTip1 }}
                  </div>
                </div>
                <div class="order-price-row">
                  <div>{{ $t(`messages.other.${typeComboPrices[3][0].name}`) }}({{ form.country }})</div>
                  <div>
                    {{ comPriceDiscountTip2 }}
                  </div>
                </div>
                <div class="order-price-row">
                  <div>{{ $t(`messages.other.${typeComboPrices[7][0].name}`) }}({{ form.country }})</div>
                  <div>
                    {{ comPriceDiscountTip3 }}
                  </div>
                </div>
              </div>
              <div class="order-price-bottom" v-else-if="!freeTrialUse && (jdCountry || mode === 'detail') && !searchKeywordTypeSupport">
                <div
                  class="order-price-row"
                >
                  <div>{{$t('messages.createCampaign.create25')}}</div>
                  <div>
                    {{ unitPriceDiscountTip }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <i class="iconfont icon-icon_tips tip-icon" @mouseenter="(e)=>showPay(e,2)"></i>
            </div>
          </section>
        </template>
        
        <section class="submit">
          <el-row justify="center" class="submit-row">
            <el-button
              type="primary"
              @click="validate"
              :disabled="mode === 'detail' && status !== 3"
              class="mr-6"
            >
              {{ showBtnText() }}
            </el-button>
            <el-button @click="backToList">{{$t('messages.createCampaign.create109')}}</el-button>
          </el-row>
        </section>
      </section>
    </div>
    <el-dialog
      class="campaign-confirm"
      :title="$t('messages.myCampaign.list38')"
      :visible.sync="confirmVisible"
      width="645px"
    >
      <div class="campaign-info">
        <template v-if="!socialMediaTypeComputed">
          <div class="row">
            <div class="label">{{$t('messages.myCampaign.list19')}}:</div>
            <div class="value">
              <img :src="mediaType && !isCombo ? form.avatar : form.icon" alt="icon" width="32" height="32" />
            </div>
          </div>
          <div class="row">
            <div class="label">{{$t('messages.myCampaign.list11')}}:</div>
            <div class="value">{{ mediaType && !isCombo ? form.reviewer_name : form.app_name }}</div>
          </div>
        </template>
        
        <div class="row" v-if="asoh5CountryAndType">
          <div class="label">Promotion Days:</div>
          <div>
            <div class="value">
              <span>{{ form.promotion_days }}</span>
            </div>
            <p class="tip-p">
              ({{$t('messages.other.other37')}})
            </p>
          </div>
        </div>
        <div class="row" v-else>
          <div class="label">{{$t('messages.myCampaign.list14')}}:</div>
          <div>
            <div class="value">
              <span style="color:#ffa922;display:inline-block;">{{ form.schedule?form.schedule[0]:'' }}</span>
              <span> – {{ form.schedule?form.schedule[1]:'' }}</span>
            </div>
            <p class="tip-p" v-if="confirmVisible">
              {{
                rightNow
                  ? `(${$t('messages.other.other38')})`
                  : `(${$t('messages.myCampaign.list39')} ${form.schedule?form.schedule[0]:''} 07:00:00 (${getTimeZ(
                      form.tz
                    )}) ${$t('messages.myCampaign.list40')})`
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="label">{{$t('messages.myCampaign.list12')}}:</div>
          <div class="value" v-if="!isCombo">{{ showLabel(setRealBT(), businessTypeOptions) }}</div>
          <div class="value" v-else>{{$t('messages.myCampaign.list13')}}</div>
        </div>
        <div class="row">
          <div class="label">{{$t('messages.myCampaign.list21')}}:</div>
          <div class="value" v-if="!isCombo">{{ sumTotalCap }}</div>
          <div class="value" v-else>{{ totalCap }}</div>
        </div>
        <div class="row" v-if="orderPriceCal">
          <div class="label">{{$t('messages.myCampaign.list22')}}:</div>
          <template v-if="freeTrialUse && !isCombo">
            <span class="value" style="text-decoration: line-through;text-decoration-color: #f56c6c;font-weight: bold;color: #f56c6c;">
              {{ unitPriceTotalTip }}
            </span>
            <span class="value" style="margin-left: 4px;color: #f56c6c;">$0</span>
          </template>
          <div class="value" v-else-if="isCombo" style="color: #f56c6c;font-weight: bold;">${{ comPriceTotal }}</div>
          <div class="value" v-else style="color: #f56c6c;font-weight: bold;">{{ unitPriceTotalTip }}</div>
        </div>
      </div>
      <div class="balance-tips" v-if="!balanceNotEnough">
        <p>{{$t('messages.createCampaign.create51')}}</p>
      </div>
      <div class="balance-tips" v-if="balanceNotEnough">
        <!-- <p>The account balance is insufficient, we still need <span style="color: #f56c6c;">
          ${{ orderPriceCalDiscount }}</span> to strart this campaing.
        </p> -->
        <p>{{$t('messages.createCampaign.create194')}} <span style="color: #f56c6c;">
          {{$t('messages.createCampaign.create195')}}{{ isCombo ? comPriceTotal : unitPriceTotal }} {{$t('messages.createCampaign.create196')}}</span> {{$t('messages.createCampaign.create197')}}
        </p>
        <p>{{$t('messages.createCampaign.create89')}}</p>
      </div>

      <div class="footer" slot="footer">
        <el-button
          type="primary"
          @click="create"
          v-if="!balanceNotEnough"
          :loading="createButtonLoading"
        >
          {{$t('messages.myCampaign.list27')}}
        </el-button>
        <el-button type="primary" @click="goDeposit" v-if="balanceNotEnough">
          {{$t('messages.myCampaign.list28')}}
        </el-button>
        <el-button
          type="text"
          @click="payItLater"
          v-if="balanceNotEnough"
          :loading="payLaterButtonLoading"
        >
          {{$t('messages.myCampaign.list54')}}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-success" :title="$t('messages.createCampaign.create155')" :visible.sync="successVisible" width="600px">
      <div class="success-content">
        <p class="icon-success-box">
          <i class="iconfont icon-circle-check"></i>
        </p>
        <p class="success-text">
          {{ $t('messages.myCampaign.list29') }}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="viewCampaignList">{{$t('messages.myCampaign.list30')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-fail" :title="$t('messages.deposit.deposit56')" :visible.sync="failVisible" width="600px">
      <div class="fail-content">
        <p class="icon-fail-box">
          <i class="iconfont icon-circle-close"></i>
        </p>
        <p class="fail-text">{{$t('messages.myCampaign.list31')}}</p>
        <p class="fail-text">
          {{$t('messages.myCampaign.list32')}}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="failVisible = false">{{$t('messages.myCampaign.list53')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog class="pay-list" :visible.sync="payListVisible" :width="popType===2?'700px':'685px'">
      <div class="pay-pop-list-body">
        <template v-if="popType===2">
          <pay-pop></pay-pop>
        </template>
        <template v-if="popType===1">
          <pay-pop-key></pay-pop-key>
        </template>
      </div>
    </el-dialog>
    <el-dialog class="create-success" :title="$t('messages.createCampaign.create80')" :visible.sync="exportVisible" width="700px">
      <div class="success-content">
        <el-tabs type="card" class="card-tabs" v-model="cardIndex">
          <el-tab-pane :label="$t('messages.home.tip58')" name="card1">
            <p>
              {{$t('messages.createCampaign.create84')}} {{$t('messages.createCampaign.create85')}} <a @click="handleDownload">{{$t('messages.createCampaign.create86')}}</a>
            </p>
            <div class="card-div">
              <ExcelParse @parseExcel="parseKeywordsExcel"></ExcelParse>
              <p>{{$t('messages.createCampaign.create82')}}</p>
            </div>
            <p class="err-tip" v-if="showPopErr" style="margin-top: 8px;">{{popErrTip}}</p>
            <div class="card-list" v-if="popTotal>0">
              <p style="margin-bottom: 20px;">{{$t('messages.createCampaign.create3')}} *</p>
              <el-form>
                <review-com 
                  :list="popList" 
                  :allList="reviewPopList" 
                  @handleReviewAdd="handleReviewAdd"
                  @handleDeleteAll="handleDeleteAll"
                  @handlePageList="handlePageList"
                  ref="reviewPopListRef"
                  type="pop"
                ></review-com>
              </el-form>
            </div>
            <div class="card-ps" v-if="popTotal>0">
              <p>{{$t('messages.createCampaign.create88')}}</p>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('messages.createCampaign.create81')" name="card2">
            <p style="margin-bottom: 10px;">
              {{ $t('messages.createCampaign.create83') }}
            </p>
            <el-input
              type="textarea"
              v-model.trim="popReview"
              :placeholder="$t('messages.createCampaign.create64')"
              autosize
              class="custom-review-input"
            ></el-input>
            <div class="card-ps" v-if="popTotal>0">
              <p>{{$t('messages.createCampaign.create88')}}</p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="footer" slot="footer">
        <el-button type="primary" @click="handleComfirm">{{$t('messages.createCampaign.create87')}}</el-button>
        <el-button @click="exportVisible=false">{{$t('messages.myCampaign.list3')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog class="create-success" :title="$t('messages.createCampaign.create76')" :visible.sync="addAppVisible" width="530px">
      <div>
        <add-app-com @callback="handleCB" type="pop" :btnText="$t('messages.createCampaign.create97')"></add-app-com>
      </div>
    </el-dialog>
    <el-dialog class="create-success" :visible.sync="previewVisible" width="350px">
      <preview-img v-if="!otherCountry && !mediaType" :iconFileList="iconFileList" :imgFileList="imgFileList"
        :hideIconUpload="hideIconUpload" :hideProductImgUpload="hideProductImgUpload" :form="form" type="pop"></preview-img>
    </el-dialog>
    <div class="preview-container-btn" @click="previewVisible=true" v-if="!otherCountry">
      <p>Preview</p>
      <img src="../../assets/img/preview-r.png" alt="preview" width="16px"/>
    </div>
    <el-dialog
      class="create-success ai-import"
      :visible.sync="aiVisible"
      width="700px"
      :before-close="handleAiDialogBeforeClose"
      @close="handleAiDialogClose"
      :title="$t('messages.createCampaign.create176')"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          ref="aiReviewRef"
          :model="aiForm"
          :rules="aiRules"
          label-position="right"
          label-width="150px"
          class="aiReview"
        >
          <el-form-item :label="`${$t('messages.createCampaign.create38')}:`" prop="language">
            <el-select v-model="aiForm.language" filterable :placeholder="$t('messages.other.other54')">
              <el-option
                v-for="(item, i) in languageOptions"
                :key="i"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('messages.createCampaign.create165')" prop="limit_reviews">
            <el-input v-model.number="aiForm.limit_reviews" type="number" :placeholder="$t('messages.createCampaign.create177')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('messages.noknow.noknow1')" prop="emoji" class="emoji-row">
            <el-radio-group v-model="aiForm.emoji">
              <el-radio :label="1" :value="1">{{ $t('messages.support.support33') }}</el-radio>
              <el-radio :label="0" :value="0">{{ $t('messages.support.support34') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('messages.createCampaign.create166')" prop="video_summary" v-if="form.business_type===11">
            <el-input
              type="textarea"
              v-model="aiForm.video_summary"
              :placeholder="$t('messages.createCampaign.create167')"
              autosize
              class="custom-review-input2"
            ></el-input>
          </el-form-item>
          <el-form-item :label="form.business_type===11?$t('messages.createCampaign.create90'):$t('messages.createCampaign.create168')" prop="additional_requirements">
            <el-input
              type="textarea"
              v-model="aiForm.additional_requirements"
              :placeholder="form.business_type===11?$t('messages.createCampaign.create169'):
              $t('messages.createCampaign.create170')"
              autosize
              class="custom-review-input2"
            ></el-input>
          </el-form-item>
          <template v-if="aiFeedback.id">
            <el-form-item :label="$t('messages.createCampaign.create171')" v-if="aiReviews.length > 0">
              <div class="tablesBox">
                <div class="tablesContent">
                  <el-table :data="aiReviews" border @selection-change="handleSelectionChange" height="0" class="aireview-table" ref="dataTable">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <el-table-column :label="$t('messages.createCampaign.create178')" type="index" width="45">
                    </el-table-column>
                    <el-table-column :label="$t('messages.createCampaign.create71')">
                      <template slot-scope="scope">{{ scope.row }}</template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('messages.createCampaign.create172')" class="feedback-form">
              <img src="../../assets/img/like-act.png" alt="like" @click="handleFeedBack" v-if="aiFeedback.like===1"/>
              <img src="../../assets/img/like-def.png" alt="like-default" @click="handleFeedBack(1)" v-else/>
              <img src="../../assets/img/unlike-act.png" alt="dislike" @click="handleFeedBack" v-if="aiFeedback.like===2"/>
              <img src="../../assets/img/unlike-def.png" alt="dislike-default" @click="handleFeedBack(2)" v-else/>
              <el-input v-model="aiFeedback.comment" :placeholder="$t('messages.other.other33')"></el-input>
            </el-form-item>
          </template>
        </el-form>
        <div class="footer aiReview-footer" slot="footer">
          <p v-if="generateButtonLoading" class="loading-tip">{{$t('messages.support.support35')}}</p>
          <template v-if="aiFeedback.id">
            <el-button @click="handleReEdit">{{$t('messages.createCampaign.create173')}}</el-button>
            <el-button type="primary" @click="handleAIImport" :disabled="selectedReviews.length===0">{{$t('messages.home.tip58')}}</el-button>
          </template>
          <el-button type="primary" v-else @click="handleGenerate" :loading="generateButtonLoading">{{$t('messages.createCampaign.create184')}}</el-button>
          <el-button @click="closeAiDialog">Cancel</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="create-success order-instruction" :title="$t('messages.createCampaign.create174')" :visible.sync="supportInfoVisible" width="500px">
      <div class="success-content">
        <p class="success-text">
          Due to specific reasons, we are currently unable to process online orders from {{ form.country }}. We kindly inform you that for 
          the {{ form.country }} region, a minimum order value of ${{ form.country==='US' ? 1250 : 625 }} is required. To complete your order process, please contact us.
        </p>
        <contact-info :type="2"></contact-info>
      </div>
    </el-dialog>
    <el-dialog class="create-success" :visible.sync="imgsPopVisible" width="1050px" :title="$t('messages.createCampaign.create58')">
      <div class="pop-imgs">
        <div v-for="(item, i) in resizeScreenshots" :key="i" class="pop-imgs-div" @click="changeChoose(item,i)">
          <img :src="item" :class="{'img1':true, 'checked':popImgIndex === i}"/>
          <img src="../../assets/img/banner-check.png" class="img2" v-if="popImgIndex === i"/>
        </div>
      </div> -->
      <div style="text-align: center;">
          <el-button type="primary" @click="confirmChoose">{{$t('messages.myCampaign.list27')}}</el-button>
        </div>
    </el-dialog>
    
    <el-dialog class="create-success launch-dialog" :visible.sync="adsVisible" width="600px" :close-on-click-modal="false">
      <div class="success-content">
        
        <p class="title">{{ $t('messages.createCampaign.create179') }}</p>
        <div class="sub-title">
          <img src="../../assets/img/huojian.png"/>
          <p>{{ $t('messages.createCampaign.create180') }}</p>
        </div>
        <p class="tip">{{ $t('messages.createCampaign.create181') }}</p>
        <div class="contact-member">
          <template v-if="contactType === 4">
            <img src="../../assets/img/wechat_code.png"/>
            <p>+86 15113373883</p>
          </template>
          <template v-else-if="contactType === 5">
            <img src="../../assets/img/kaokaotalk_code.png"/>
            <p>doriaho</p>
            </template>
          <template v-else>
            <img src="../../assets/img/contact-p.png"/>
            <p>Doria</p>
          </template>
        </div>
        <div class="contact-list">
          <div 
            class="contact-list-item" 
            v-for="(item, index) in contacts" 
            :key="item.type"
            @click="(val)=>chooseContactType(val,item.type)"
          >
            <img 
              :src="require(`../../assets/img/${item.icon}.png`)"
              v-if="contactType === index + 1"
            />
            <img 
              :src="require(`../../assets/img/${item.iconD}.png`)"
              v-else
            />
          </div>
        </div>
      </div>
      <div v-if="contactShowBtn.includes(contactType)">
          <div class="contact-btn" @click="toContact">Click to contact</div>
        </div>
    </el-dialog>
  </el-card>
</template>

<script>
import payPop from './component/payPop.vue'
import payPopKey from './component/payPopKey.vue'
import reviewCom from './component/reviewCom.vue'
import campaignRules from '../../mixins/campaignCreate'
import excelParseMixins from '../../mixins/excelParse'
import ExcelParse from './component/excelParse.vue'
import addAppCom from '../../components/addAppCom.vue';
import previewImg from './component/previewImg.vue';
import contactInfo from '@/components/contactInfo.vue'
export default {
  components:{
    payPop,
    payPopKey,
    reviewCom,
    ExcelParse,
    addAppCom,
    previewImg,
    contactInfo,
  },
  mixins:[campaignRules,excelParseMixins],
}
</script>

<style lang="scss">
@import './campaignCreate.scss';
</style>

